const OPEN_GENERATE_FIRST_SECRET_WIZARD = 'OPEN_GENERATE_FIRST_SECRET_WIZARD';
const CLOSE_GENERATE_FIRST_SECRET_WIZARD = 'CLOSE_GENERATE_FIRST_SECRET_WIZARD';
const NEXT_STEP_GENERATE_FIRST_SECRET = 'NEXT_STEP_GENERATE_FIRST_SECRET';

export { OPEN_GENERATE_FIRST_SECRET_WIZARD, CLOSE_GENERATE_FIRST_SECRET_WIZARD, NEXT_STEP_GENERATE_FIRST_SECRET };
